import $ from 'jquery';
import anime from 'animejs';
import Utils from '../utils/Utils.js';
import { resizeScroll } from '../core/ScrollService.js';
const initCollapses = () => {
    if (document.querySelectorAll('[data-collapse]')) {
        document.querySelectorAll('[data-collapse]').forEach((collapse) => {
            let collapseToggle = collapse.querySelector('[data-collapse-toggle]');
            let collapseContent = collapse.querySelector('[data-collapse-content]');
            if (collapse.hasAttribute('data-open')) {
                let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                collapse.toggleAttribute('data-collapse-opened');
                anime({
                    targets: collapseContent,
                    height: contentHeight,
                    duration: 0,
                    complete: () => {
                        resizeScroll();
                    }
                });
            }
            collapseToggle.addEventListener('click', (e) => {
                let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                collapse.toggleAttribute('data-collapse-opened');
                if (collapse.closest('[data-collapse-content]')) {
                    let parent = collapse.closest('[data-collapse-content]')
                    anime({
                        targets: parent,
                        height: collapse.hasAttribute('data-collapse-opened') ? parent.offsetHeight + contentHeight : parent.offsetHeight - contentHeight,
                        easing: 'easeOutExpo',
                        duration: 600,
                        complete: () => {
                            resizeScroll();
                        }
                    });
                }
                anime({
                    targets: collapseContent,
                    height: collapse.hasAttribute('data-collapse-opened') ? contentHeight : 0,
                    easing: 'easeOutExpo',
                    duration: 600,
                    complete: () => {
                        resizeScroll();

                    }
                });
            })
        });

        const resizeCollapsesContents = () => {
            if (document.querySelectorAll('[data-collapse-opened]')) {
                document.querySelectorAll('[data-collapse-opened]').forEach((collapse) => {
                    let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                    collapse.querySelector('[data-collapse-content]').style.height = contentHeight + 'px';
                });
            }
        };

        window.addEventListener('resize', Utils.debounce(() => { resizeCollapsesContents() }), { passive: true });
    }
};

export { initCollapses };
